import { render, staticRenderFns } from "./PartnerBar.vue?vue&type=template&id=0c9c7468&"
import script from "./PartnerBar.vue?vue&type=script&lang=ts&"
export * from "./PartnerBar.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports